import React, {Fragment, memo, useRef} from 'react';
import {useSelector} from 'react-redux';

import {translate} from '@mapsight/ui/src/js/helpers/i18n';

import {viewSelector} from '@mapsight/ui/src/js/store/selectors';
import {VIEW_DESKTOP} from '@mapsight/ui/src/js/config/constants/app';

import {detailsFeatureSelector} from '../../../mapsight-glue/store/selectors';
import {useNavPos} from '../../../hooks';

import Image from '../image';
import Header from './header';
import {isDefined} from '../../../modules/helpers';


function PageHead({}) {
	const navPos = useNavPos();
	const view = useSelector(viewSelector);
	const detailsFeature = useSelector(detailsFeatureSelector);
	const featureProperties = detailsFeature?.properties || {};
	const pageHeadRef = useRef();


	const leadImage = navPos.deepLink ? featureProperties?.leadImage :
		(navPos.home
			|| ((navPos.list || navPos.listMorePoi) && view === VIEW_DESKTOP)
		) ?
			navPos?.app?.leadImage :
			null;
	const title = navPos.deepLink ? (featureProperties?.name || detailsFeature?.id) : navPos?.app?.title;
	const subheading = navPos.deepLink ? featureProperties?.subheading :
		navPos.list ? translate('stade.list.heading') :
			navPos.listMorePoi ? translate('stade.list.moreHeading') :
				navPos?.app?.subheading;

	return (
		<div className="stade-page-head" ref={pageHeadRef} >
			<Header forceShowScrollable={!isDefined(leadImage)} pageHeadRef={pageHeadRef} />

			{!navPos.map && (
				<div className="stade-lead">
					{isDefined(leadImage) && (
						<Image
							className="stade-page-head__lead-image"
							image={leadImage}
						/>
					)}
					<div className="ms3-map-row ms3-flex ms3-flex--row">
						<header>
							<h1>{title || ''}</h1>
							<p>{subheading || ''}</p>
						</header>
					</div>
				</div>
			)}
		</div>
	);
}

export default memo(PageHead);
